<template>
  <div class="header d-flex ai-center jc-between">
    <div class="header-left d-flex ai-center">
      <img src="../assets/logo.png" @click="goHome" />
      <a class="text-gray-1" href="http://swap.transit.finance/">
        {{ $t('swap') }}
      </a>
      <a class="text-gray-1" href="https://buy.transit.finance/">
        {{ $t('buyToken') }}
      </a>
      <a class="text-gray-1" href="https://tokensecurity.tokenpocket.pro/">
        {{ $t('security') }}
      </a>
    </div>
    <div class="header-right d-flex ai-center">
      <div
        class="language box-bg-2 d-flex ai-center jc-center"
        @click="changeMode"
      >
        <img :src="moonImg" v-if="isDark" />
        <img :src="sunImg" v-else />
      </div>
      <div
        class="language box-bg-2 style-mode d-flex ai-center jc-center"
        @click="changeLang"
      >
        <img :src="enImg" v-if="$i18n.locale === 'en'" />
        <img :src="zhImg" v-else />
      </div>
    </div>
    <img
      class="menu"
      src="../assets/more-dark.png"
      v-if="isDark"
      @click="onMenu"
    />
    <img class="menu" src="../assets/more.png" v-else @click="onMenu" />
    <MenuMobile v-if="isMenuMobile" @close="closeMenuMobile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuMobile from './MenuMobile.vue'

export default {
  data() {
    return {
      isMenuMobile: false,
    }
  },
  components: { MenuMobile },
  computed: {
    ...mapGetters(['isDark']),
    moonImg() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return require(`../assets/moon${str}.png`)
    },
    sunImg() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return require(`../assets/sun${str}.png`)
    },
    zhImg() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return require(`../assets/zh${str}.png`)
    },
    enImg() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return require(`../assets/en${str}.png`)
    },
  },
  created() {
    document.body.style.overflow = 'auto'
    window.removeEventListener('touchmove', this.isScroll)
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
    window.removeEventListener('touchmove', this.isScroll)
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    onMenu() {
      this.isMenuMobile = !this.isMenuMobile
      if (this.isMenuMobile) {
        document.body.style.overflow = 'hidden'
        // ios 禁止橡皮筋效果
        window.addEventListener('touchmove', this.isScroll, { passive: false })
      } else {
        document.body.style.overflow = 'auto'
        window.removeEventListener('touchmove', this.isScroll)
      }
    },
    isScroll(e) {
      e.stopPropagation()
      e.preventDefault()
    },

    closeMenuMobile() {
      this.isMenuMobile = false
      document.body.style.overflow = 'auto'
      window.removeEventListener('touchmove', this.isScroll)
    },
    changeLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh'
      } else {
        this.$i18n.locale = 'en'
      }
      window.localStorage.setItem('locale', this.$i18n.locale)
    },
    changeMode() {
      this.$store.commit('setDark', !this.isDark)
      if (!document.documentElement.hasAttribute('theme')) {
        document.documentElement.setAttribute('theme', 'dark')
        window.localStorage.setItem('mode', 'dark')
      } else {
        document.documentElement.removeAttribute('theme')
        window.localStorage.setItem('mode', 'light')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  // margin-top: 0.54rem;
  padding-top: 0.54rem;
  .header-left {
    img {
      width: 1.35rem;
      height: 0.36rem;
      display: inline-block;
      cursor: pointer;
    }
    a {
      margin-left: 0.4rem;
      cursor: pointer;
    }
  }
  .header-right {
    .language {
      width: 0.36rem;
      height: 0.36rem;
      border-radius: 0.12rem;
      cursor: pointer;
      img {
        width: 0.16rem;
        height: 0.16rem;
      }
    }
    .style-mode {
      margin-left: 0.1rem;
    }
  }
  .menu {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .header {
    .header-left {
      img {
        width: 2.09rem;
        height: 0.56rem;
      }
      a {
        display: none;
      }
    }
    .header-right {
      display: none;
    }
    .menu {
      display: block;
      width: 0.56rem;
      height: 0.56rem;
    }
  }
}
</style>
